import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "17.778",
      height: "11.429",
      x: "1.111",
      y: "6.032",
      stroke: "currentColor",
      "stroke-width": "1.5",
      rx: "1"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M6.19 6.032v-2.81a1 1 0 0 1 1-1h5.62a1 1 0 0 1 1 1v2.81"
    }, null, -1)
  ]))]))
}
export default { render: render }